/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { ReactNode } from 'react';
import { authService } from 'services/auth/AuthService';
import { DashboardType } from 'jotai/dashboard';
import UnauthorizedDialog from '../UnauthorizedDialog/UnauthorizedDialog';

interface AuthorizedRouteProps {
  children: ReactNode;
  authRoles: string[];
  type: DashboardType;
}
const AuthorizedRoute = ({ children, authRoles, type }: AuthorizedRouteProps) => {
  const userRoles = authService.getRolesAllRealms();
  // If the user does not have the required role, redirect to the home page
  if (!userRoles || !userRoles?.some((item) => authRoles.includes(item))) {
    if (type === DashboardType.ImageGallery) {
      return <UnauthorizedDialog redirectUrl="/image-gallery" />;
    } else {
      return <UnauthorizedDialog redirectUrl="/" />;
    }
  }
  return <>{children}</>;
};

export default AuthorizedRoute;
